KXL.module('GamesApp.Gallery', function(Gallery, KXL, Backbone, Marionette, $, _) {
	Gallery.Controller = {
		getGallery: function () {
			return new Gallery.View();
		}
	};
});
